
<div *ngIf="icon"><i class="fad fa-3x fa-{{icon}}"></i></div>
<h4>{{text}}</h4><span *ngIf="!hintPermission || identity.hasPermission(hintPermission)">{{hint}}</span>
<ng-content></ng-content>